<template>
  <div>
    <h6 v-if="quote.switchType == 'dualConsolidatedToDualConsolidated'">
      How do you pay for your gas & electricity bill?
    </h6>
    <h6 v-else-if="quote.switchType == 'gasToGas'">How do you pay for your gas bill?</h6>
    <h6 v-else-if="quote.switchType == 'electricityToElectricity'">How do you pay for your electricity bill?</h6>
    <h6 v-else>
      How do you pay for your {{ quote.editMode.prop == 'gasCurrentPayMethod' ? 'gas' : 'electricity' }} bill?
    </h6>

    <div class="row">
      <div class="col-xs-12" v-if="!showPrepayment">
        <radio-button v-model="form.paymentType" value="monthlyDirectDebit" :error="$v.form.paymentType.$error">Monthly
          Direct Debit
        </radio-button>
      </div>

      <div class="col-xs-12" v-if="!showPrepayment">
        <radio-button v-model="form.paymentType" value="quarterlyDirectDebit" :error="$v.form.paymentType.$error">
          Quarterly Direct Debit
        </radio-button>
      </div>

      <div class="col-xs-12" v-if="!showPrepayment">
        <radio-button v-model="form.paymentType" value="cashOrCheque" :error="$v.form.paymentType.$error">
          Cash & Cheque
        </radio-button>
      </div>

      <div class="col-xs-12" v-if="showPrepayment != false">
        <radio-button v-model="form.paymentType" value="prePaymentMeter" :error="$v.form.paymentType.$error">
          Prepayment
        </radio-button>
      </div>
    </div>

    <div class="sticky-footer">
      <div class="col-xs-5">
        <uiv-btn type="link" block @click="onBack">Back</uiv-btn>
      </div>
      <div class="col-xs-7">
        <uiv-btn type="primary" block @click="onSave">Save & Next</uiv-btn>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';
import { requiredIf } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'PaymentType',
  data() {
    return {
      form: {
        paymentType: null
      }
    }
  },
  validations() {
    return {
      form: {
        paymentType: {
          requiredIf: requiredIf(form => !form.paymentType)
        }
      }
    }
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      showPrepayment: ({ quote }) => {
        if (quote.compareFuel == 'electricity' || quote.compareFuel == 'gas') {
          return quote.currentPayMethed == 'prePaymentMeter';
        }

        if (quote.compareFuel == 'gasElectricity') {
          return quote.gasCurrentPayMethod == 'prePaymentMeter' && quote.electricityCurrentPayMethod == 'prePaymentMeter';
        }

        return false;
      }
    })
  },
  methods: {
    ...mapActions({
      goToQuestion: 'quote_questions/goToQuestion',
      getSuppliers: 'lookups/getSuppliers'
    }),
    onBack() {
      this.goToQuestion('home');
      this.form.paymentType = null;
      this.$v.form.paymentType.$reset();
    },
    async onSave() {
      this.$v.form.paymentType.$touch();
      if (this.$v.form.paymentType.$invalid) return;

      // reset supplier and tariff
      this.quote[this.quote.editMode.prop] = this.form.paymentType;

      if (this.quote.editMode.prop == 'currentPayMethod') {
        this.quote.supplierId = null;
        this.quote.supplierName = null;
        this.quote.tariffId = null;
        this.quote.tariffName = null;
        this.quote.tariffValidToDate = null;
        this.getSuppliers({ fuelType: this.quote.compareFuel, paymentKey: 'currentPayMethod' });
        this.quote.editMode.prop = 'supplierId';
      }

      if (this.quote.editMode.prop == 'electricityCurrentPayMethod') {
        this.quote.electricitySupplierId = null;
        this.quote.electricitySupplierName = null;
        this.quote.electricityTariffId = null;
        this.quote.electricityTariffName = null;
        this.quote.electricityTariffValidToDate = null;
        this.getSuppliers({ fuelType: 'electricity', paymentKey: 'electricityCurrentPayMethod' });
        this.quote.editMode.prop = 'electricitySupplierId';
      }

      if (this.quote.editMode.prop == 'gasCurrentPayMethod') {
        this.quote.gasSupplierId = null;
        this.quote.gasSupplierName = null;
        this.quote.gasTariffId = null;
        this.quote.gasTariffName = null;
        this.quote.gasTariffValidToDate = null;
        this.getSuppliers({ fuelType: 'gas', paymentKey: 'gasCurrentPayMethod' });
        this.quote.editMode.prop = 'gasSupplierId';
      }


      this.goToQuestion('supplierTariff');
      this.form.paymentType = null;
      this.$v.form.$reset();

      this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Payment Type' });
      this.$store.dispatch('tracing/addAction', { name: 'Action', value: 'Chosen' });
      await this.$store.dispatch('tracing/saveActions');
    }
  },
  components: {
    RadioButton
  }
};
</script>

<style lang="scss"></style>
